import { render, staticRenderFns } from "./Featurelist.vue?vue&type=template&id=4a79ea85&"
import script from "./Featurelist.vue?vue&type=script&lang=js&"
export * from "./Featurelist.vue?vue&type=script&lang=js&"
import style0 from "./Featurelist.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports